import {
  Component,
  OnDestroy,
  OnInit,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';
import { APIService } from '../../../../../api/api.service';
import { NotifierService } from '../../../../../_services/notifier.service';
import { regions } from './../../../../../dash/dash.component';
import { environment } from 'src/environments/environment';

declare let $: any;
declare let flatpickr: any;

@Component({
  selector: 'mrr-enableri-update',
  templateUrl: './update.enableri.component.html',
  styleUrls: ['./update.enableri.component.css'],
})
export class MrrEnableRIUpdateComponent implements OnInit, OnDestroy {
  additionalContacts: string[] = [''];
  userId = localStorage.getItem('eId');
  ut = localStorage.getItem('ut');
  regions: any = regions;
  urlPrefix: any = localStorage.getItem('role') == 'Admin' ? 'admin' : 'client';
  writeAccess: boolean =
    localStorage.getItem('acT') == 'readandwrite' ||
    this.urlPrefix == 'admin' ||
    localStorage.getItem('ut') == 'admin';
  loading = true;
  accountId: any;
  regionId: any;
  dateRange: any;
  RITypes: any = [];
  currentMessage: any;
  @Output() hideModel = new EventEmitter<any>();
  @Input() ri: any;
  @Input('action') action: any;
  instanceTypes: any;
  platformTypes: any;
  accounts: any;
  childs: any;
  linkedAccounts: any;
  lids: any;
  constructor(
    private apiService: APIService,
    private notifier: NotifierService,
  ) {}

  ngOnInit(): void {
    console.log('ri');
    this.ri = { ...this.ri };

    this.accountId = localStorage.getItem('accountId');
    this.regionId = localStorage.getItem('regionId');

    this.linkedAccounts = JSON.parse(
      localStorage.getItem('accountIdData') || '{}',
    );

    if (Array.isArray(this.linkedAccounts.list)) {
      this.accounts = this.linkedAccounts.list.map(
        (accountObj: any) => accountObj.account,
      );
    } else {
      console.error(
        'childs does not have a valid list key or it is not an array.',
      );
    }

    // ✅ Initialize selectpickers
    setTimeout(() => {
      $('#regionsList').selectpicker('refresh');
      $('#childs').selectpicker('refresh');
    }, 100);

    // ✅ Fetch dropdown data immediately on open
    this.load(); // <--- ADD THIS

    this.currentMessage = this.notifier.currentMessage.subscribe((msg) => {
      const d = JSON.parse(msg);
      if (d.value == null) return;
      if (d.key === 'accountId') {
        this.accountId = d.value;
        this.load();
      } else if (d.key === 'regionId') {
        this.regionId = d.value;
        this.load();
      }
    });

    if (this.action == 'update') {
      this.dateRange = this.ri.startDate + ' to ' + this.ri.endDate;

      // ✅ Init flatpickr AFTER dateRange is set, with destroy guard
      setTimeout(() => {
        const el = document.querySelector('#dataRangePicker') as any;
        if (el?._flatpickr) {
          el._flatpickr.destroy();
        }
        flatpickr('#dataRangePicker', {
          dateFormat: 'Y-m-d',
          mode: 'range',
          defaultDate: [this.ri.startDate, this.ri.endDate],
          showMonths: 2,
          onChange: (selectedDates: any, dateStr: any, instance: any) => {
            if (!dateStr.includes('to')) return;
            this.dateRange = dateStr;
          },
        });
      }, 500);
    } else {
      // For add action, init without defaultDate
      flatpickr('#dataRangePicker', {
        dateFormat: 'Y-m-d',
        mode: 'range',
        showMonths: 2,
        onChange: (selectedDates: any, dateStr: any, instance: any) => {
          if (!dateStr.includes('to')) return;
          this.dateRange = dateStr;
        },
      });
    }
  }

  load() {
    this.fetchInstanceTypes();
    this.fetchRITypes();
    this.fetchPlatformsTypes();
  }

  selectAllchilds(event: any) {
    const isChecked = event.target.checked;

    if (isChecked) {
      // Select all accounts
      this.ri.lids = this.linkedAccounts['list'].map(
        (account: any) => account.accountId,
      );
    } else {
      // Deselect all accounts
      this.ri.lids = [];
    }
    setTimeout(() => {
      $('#childs').selectpicker('refresh');
    }, 10);
  }

  async fetchRICost() {
    let instanceType: string = $('#instanceTypes').val();
    let os: string = $('#platformsList').val();
    let region: string = $('#regionsList').val();
    let bt: string = $('#billingTypes').val();
    if (
      !instanceType ||
      !os ||
      !region ||
      !bt ||
      this.ri.riType == 'OnDemand'
    ) {
      return;
    }
    this.notifier.loading(true);
    let data = {
      accountId: this.accountId,
      action: 'fetchRiPrice',
      instanceType: instanceType,
      os: os,
      region: region,
      riType: bt,
    };
    let header = {
      Authorization: localStorage.getItem('t'),
    };

    let apiURL = `${environment.apiURL}/admin/billing/fetchripurchaseorder`;

    let result = await this.apiService.postDataPromis(apiURL, data, header);
    if (result.status == '1' || result.s == '1') {
      this.ri.riCost = result.onDemandCost;
    } else {
      this.notifier.alert('Info', '', result.msg, 'info', 5000);
    }
    this.notifier.loading(false);
  }

  async fetchInstanceTypes() {
    this.notifier.loading(true);
    let data = { action: 'fetchInstanceTypes', region: this.regionId };

    let header = {
      Authorization: localStorage.getItem('t'),
    };
    let apiURL = `${APIService.API_ENDPOINTV3}/${this.urlPrefix}/bom/fetchbomdetails`;

    let result = await this.apiService.postDataPromis(apiURL, data, header);

    if (result.status == '1' || result.s == '1') {
      this.instanceTypes = result.instanceTypeList;
      setTimeout(() => {
        $('#instanceTypes').selectpicker('refresh');
      }, 100);
    } else {
      this.notifier.alert('Info', '', result.error, 'info', 5000);
    }
  }

  async fetchRITypes() {
    this.notifier.loading(true);
    let data = { action: 'fetchBillingType', accountId: this.accountId };

    let header = {
      Authorization: localStorage.getItem('t'),
    };
    let apiURL = `${APIService.API_ENDPOINTV3}/${this.urlPrefix}/bom/fetchbomdetails`;

    let result = await this.apiService.postDataPromis(apiURL, data, header);

    if (result.status == '1' || result.s == '1') {
      this.RITypes = result.billingTypeList;
      setTimeout(() => {
        $('#billingTypes').selectpicker('refresh');
      }, 100);
    } else {
      this.notifier.alert('Info', '', result.error, 'info', 5000);
    }
  }

  async fetchPlatformsTypes() {
    this.notifier.loading(true);
    let data = { action: 'fetchPlatformDetails', accountId: this.accountId };

    let header = {
      Authorization: localStorage.getItem('t'),
    };
    let apiURL = `${APIService.API_ENDPOINTV3}/${this.urlPrefix}/bom/fetchbomdetails`;

    let result = await this.apiService.postDataPromis(apiURL, data, header);

    if (result.status == '1' || result.s == '1') {
      this.platformTypes = result.billingTypeList;
      setTimeout(() => {
        $('#platformsList').selectpicker('refresh');
      }, 100);
    } else {
      this.notifier.alert('Info', '', result.error, 'info', 5000);
    }
    this.notifier.loading(false);
  }

  async updateEntry() {
    let sDate = $('.datetimepicker').val().split(' to ');
    let start_date = sDate[0];
    let end_date = sDate[1];
    if (this.action.trim() == 'save') {
      this.close({
        accountId: '-',
        action: 'save',
        riDetailsList: [
          {
            id: this.ri.id,
            instanceType:
              this.ri.riType != 'OnDemand' ? $('#instanceTypes').val() : '',
            os: $('#platformsList').val(),
            region: this.ri.riType != 'OnDemand' ? $('#regionsList').val() : '',
            quantity: this.ri.quantity,
            riType: $('#billingTypes').val(),
            discountPercentage: this.ri.discountPercentage,
            startDate: start_date,
            endDate: end_date,
            riCost: this.ri.riType != 'OnDemand' ? this.ri.riCost : '',
          },
        ],
        lids: this.ri.lids,
      });
      return;
    }
    this.notifier.loading(true);
    let data: any = {
      accountId: this.accountId,
      action: 'update',
      instanceType:
        this.ri.riType != 'OnDemand' ? $('#instanceTypes').val() : undefined,
      os: $('#platformsList').val(),
      region:
        this.ri.riType != 'OnDemand' ? $('#regionsList').val() : undefined,
      quantity: this.ri.quantity,
      riType: $('#billingTypes').val(),
      discountPercentage: this.ri.discountPercentage,
      startDate: start_date,
      endDate: end_date,
      id: this.ri.id,
      riCost: this.ri.riType != 'OnDemand' ? this.ri.riCost : undefined,
    };

    let header = {
      Authorization: localStorage.getItem('t'),
    };
    // let apiURL =
    let apiURL = `${environment.apiURL}/admin/billing/fetchripurchaseorder`;

    let result = await this.apiService.postDataPromis(apiURL, data, header);

    if (result.status == '1' || result.s == '1') {
      this.notifier.alert('Success', '', result.msg, 'success', 5000);
      this.close(true);
    } else {
      this.notifier.alert('Info', '', result.msg, 'info', 5000);
    }

    this.notifier.loading(false);
  }

  ngOnDestroy(): void {}

  trackByFn() {
    return true;
  }

  close(dataAction: any) {
    console.log('close function' + dataAction);
    if (dataAction) {
      this.hideModel.emit(dataAction);
    } else {
      this.hideModel.emit(dataAction);
    }
  }
  getFormData(): { isValid: boolean; data?: any; errors: string[] } {
    const errors: string[] = [];

    const dateRangeVal = this.dateRange;

    if (!dateRangeVal || !dateRangeVal.includes('to')) {
      errors.push('Please select a valid date range');
    }

    const instanceType = this.ri.instanceType;
    const os = this.ri.os;
    const region = this.ri.region;
    const riType = this.ri.riType;

    const isOnDemand = riType === 'OnDemand';

    if (!isOnDemand && !instanceType) {
      errors.push('Please select an Instance Type');
    }

    if (!os) {
      errors.push('Please select an OS / Platform');
    }

    if (!isOnDemand && !region) {
      errors.push('Please select a Region');
    }

    if (!this.ri.quantity || Number(this.ri.quantity) <= 0) {
      errors.push('Please enter a valid Quantity (must be greater than 0)');
    }

    if (!riType) {
      errors.push('Please select an RI Type');
    }

    if (!isOnDemand && !this.ri.riCost) {
      errors.push('Please enter the RI Hourly Cost');
    }

    if (!this.ri.discountPercentage) {
      errors.push('Please enter a Discount Percentage');
    }

    if (errors.length > 0) {
      return { isValid: false, errors };
    }

    const [startDate, endDate] = dateRangeVal
      .split('to')
      .map((d: string) => d.trim());

    const data = {
      accountId: this.accountId,
      action: this.action?.trim(),
      riDetailsList: [
        {
          id: this.ri.id,
          instanceType: instanceType,
          os,
          region: region,
          quantity: this.ri.quantity,
          riType,
          discountPercentage: this.ri.discountPercentage,
          startDate,
          endDate,
          riCost: this.ri.riCost,
        },
      ],
      // lids: this.ri.lids ?? [],
    };
    console.log('data', data);
    return { isValid: true, data, errors: [] };
  }
}
